// extracted by mini-css-extract-plugin
export default {"errorBg":"#f8d7da","errorText":"#721c24","blockedBadgeWrapper":"blockedBadgeWrapper---N8MZP","blockedBadge":"blockedBadge---Xmtk_","blockReason":"blockReason---xRcNZ"};